import type { Dayjs } from 'dayjs';
import type HotelAndMarketService from 'lumen/services/hotel-and-market';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function generateRecommendationsRequestDaterange(
  hotelAndMarketService: HotelAndMarketService,
  monthDayjs: Dayjs,
) {
  // no need to request recommendations for past days or outside the selected month as we don't show them
  let dateRangeStartForRecommendationsRequest = null;
  let dateRangeEndForRecommendationsRequest = null;

  const today = hotelAndMarketService.getLocalTime();

  // Case1: selected month is the current month: request recommendations from today
  // Case2: selected month is a future month: request recommendations from start of the selected month
  if (today.isSame(monthDayjs, 'month')) {
    dateRangeStartForRecommendationsRequest = today.format('YYYY-MM-DD');
  } else {
    dateRangeStartForRecommendationsRequest = monthDayjs
      .startOf('month')
      .format('YYYY-MM-DD');
  }

  // request recommendations until the last day of selected month, extended to the end of last week
  dateRangeEndForRecommendationsRequest = monthDayjs
    .endOf('month')
    .endOf('week')
    .format('YYYY-MM-DD');

  return {
    dateRangeStartForRecommendationsRequest,
    dateRangeEndForRecommendationsRequest,
  };
}
